import { FileText } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white\">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white sticky top-0 z-10\">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-3\">
          <a href="/\" className="flex items-center gap-2\" data-testid="terms-logo-link\">
            <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center\">
              <FileText className="h-4 w-4 text-white\" />
            </div>
            <span className="font-semibold text-slate-900\">Canva For Resume</span>
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16\">
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2\" data-testid="terms-heading\">
          Terms of Service
        </h1>
        <p className="text-sm text-slate-500 mb-10\">Last updated: February 1, 2026</p>

        <div className="prose prose-slate max-w-none space-y-8\" data-testid="terms-content\">
          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">1. Acceptance of Terms</h2>
            <p className="text-slate-600 leading-relaxed\">
              By accessing and using Canva For Resume (\"Service\"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">2. Description of Service</h2>
            <p className="text-slate-600 leading-relaxed\">
              Canva For Resume provides an AI-powered resume optimization service. Users can upload their existing resumes, provide a job description, and receive an optimized version tailored for Applicant Tracking Systems (ATS) and the specific role.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">3. User Accounts</h2>
            <p className="text-slate-600 leading-relaxed\">
              You are responsible for maintaining the confidentiality of your account credentials. You agree to accept responsibility for all activities that occur under your account. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">4. Credits and Payments</h2>
            <p className="text-slate-600 leading-relaxed\">
              The Service operates on a credit-based model. Credits are required to download optimized resumes. Credit purchases are processed through our payment partner Razorpay. All purchases are subject to our Refund Policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">5. Intellectual Property</h2>
            <p className="text-slate-600 leading-relaxed\">
              You retain all rights to the content you upload to the Service. The optimized output is generated for your personal use. You may use the output for job applications or any lawful purpose. The Service's technology, branding, and interface remain the intellectual property of Triplenine Labs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">6. Limitation of Liability</h2>
            <p className="text-slate-600 leading-relaxed\">
              The Service is provided \"as is\" without warranties of any kind. We do not guarantee that the optimized resume will result in job interviews or employment. We shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">7. Changes to Terms</h2>
            <p className="text-slate-600 leading-relaxed\">
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of the Service following any changes indicates your acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3\">8. Contact Us</h2>
            <p className="text-slate-600 leading-relaxed\">
              If you have any questions about these Terms of Service, please contact us at support@tripleninelabs.com.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 py-6\">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-slate-500\">
          &copy;2026 Canva For Resume, a product of Triplenine Labs.
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
